
export const MessageType = {
    Error: "[ERR]",
    Warning: "[WAR]",
    Info: "[INF]",
};

export const Message = {
    AuthError: "Autenticazione richiesta per accedere al servizio.",
    AuthInvalidUser: "Utente non autorizzato.",

    ServerConnectionError: "Impossibile stabilire la connessione con il server.",
    ServerRequestError: "Errore servizio",

    QueryError: "Errore durante l'esecuzione query del metodo ",

    EmptyData: "EmptyData",

    CreateLicenseError: "Errore durante la creazione della licenza: ",

    PKNotFound: "Product Key non trovato.",

    CodiceModuliPrimaAttivazione: "Nessuna configurazione moduli è stata trovata per la licenza specificata. E' richiesta una prima attivazione.",

    EmailSent: "Email inviata con successo",
    EmailEmpty: "Email non può essere vuota",
    EmailError: "Anomalia invio Email: ",
    EmailInvalidFormat: "Email in formato non valido",

    Blocked: "blocked",
    NotBlocked: "not blocked",
    Unblocked: "unblocked",
    NotUnblocked: "not unblocked",

    // operazioni DB
    Inserted: "inserted",
    NotInserted: "not inserted",
    Updated: "updated",
    NotUpdated: "not updated",


    LicenseUnlinked: "unlinked",
    LicenseNotUnlinked: "not unlinked ",
    LicenseNoAssociatedHW: "Nessun Hardware associato.",


    // per i metodi che ritornano DataTable
    AUTH_ERROR: "AuthError",
    AUTH_INVALID_USER: "AuthInvalidUser",
    SERVER_REQUEST_ERROR: "ServerRequestError",
};
